import React from "react";
import { NavLink, useHistory } from "react-router-dom";

import {
  Button,
  Flex,
  Text,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";

import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import OutgoingForm, { handleDataBeforeSubmit } from "./OutgoingForm";
import { outgoingSchema } from "./yupSchema";
import { useCreateOutgoing } from "hooks/outgoings";
import dateFormat from "functions/dateFormat";

const CreateOutgoing = () => {
  const toast = useToast();
  const history = useHistory();

  const methods = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
    resolver: yupResolver(outgoingSchema),
  });

  const { handleSubmit, reset } = methods;

  const [createOutgoing, { data, loading, error }] = useCreateOutgoing({
    onSuccess: (data) => {
      reset();
      toast({
        title: "Gasto criado com sucesso.",
        status: "success",
        duration: 5000,
        isClosable: true,
      }),
        history.push(
          `/sistema/financeiro/saidas/${data.createOutgoing.id}`
        );
    },
    onError: (err) => {
      console.log(err);
      toast({
        title: "Ocorreu um erro",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },
  });

  const onSubmit = (data) => {
    data = handleDataBeforeSubmit(data);
    const variables = {
      input: {
        ...data,
      },
    };

    createOutgoing({ variables: variables });
  };

  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Flex
      direction="column"
      minH="100vh"
      align="center"
      pt={{ sm: "120px", lg: "160px" }}
    >
      <Card w={{ md: "100%", lg: "50%" }}>
        <CardHeader mb="40px">
          <Flex direction="column">
            <Text color={textColor} fontSize="lg" fontWeight="bold" mb="3px">
              Criar Gasto
            </Text>
            <Text color="gray.400" fontWeight="normal" fontSize="sm">
              Preencha os campos para realizar o cadastro
            </Text>
          </Flex>
        </CardHeader>
        <CardBody>
          <FormProvider {...methods}>
            <form style={{ width: "100%" }} onSubmit={handleSubmit(onSubmit)}>
              <Flex direction="column" w="100%">
                <OutgoingForm />
                <Flex mt="24px" align={"center"} justify={"flex-end"}>
                  <NavLink to="/sistema/financeiro/saidas">
                    <Text
                      mr="20px"
                      fontSize="xs"
                      color={textColor}
                      fontWeight="bold"
                    >
                      Cancelar
                    </Text>
                  </NavLink>
                  <Button
                    isLoading={loading}
                    type="submit"
                    variant="no-hover"
                    bg="governance.700"
                    alignSelf="flex-end"
                    w="100px"
                    h="35px"
                  >
                    <Text fontSize="xs" color="#fff" fontWeight="bold">
                      Criar
                    </Text>
                  </Button>
                </Flex>
              </Flex>
            </form>
          </FormProvider>
        </CardBody>
      </Card>
    </Flex>
  );
};

export default CreateOutgoing;
